import actionConsts from '../../constants/actions';

const currentMail = (state = {}, action = {}) => {
    switch (action.type) {
        case actionConsts.SET_CURRENT_MAIL_INDEX:
            return {
                ...state,
                index: action.payload
            }

        default:
            return state;
    }
}

export default currentMail;


// WEBPACK FOOTER //
// /src/reducers/uiState/currentMail.js